<script setup lang="ts">
import { type IconName, MaterialIcons } from './material-icon'

const props = defineProps<{
  name: IconName
  title?: string
}>()
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <title v-if="title">{{ title }}</title>
    <path :d="MaterialIcons[props.name]" />
  </svg>
</template>
